export const VersionRouting = {
  path: "/version",
  name: "version",
  meta: { title: "版本介绍" },
  component: () => import(/* webpackChunkName: "login" */ "@/views/version/index.vue"),
};
